export default "__VITE_ASSET__teMA$ZYA__"